import { Component } from '@nicolas-riciotti/light2';

export default class BlockNav extends Component {
    attached() {
        this.$links = Array.from(this.querySelectorAll('a[data-nav-target]'));
        this.entries = [];

        this.$links.forEach((link) => {
            const targetSelector = link.getAttribute('data-nav-target');
            if (!targetSelector || targetSelector === '#') return;
            let section = null;
            try {
                section = document.querySelector(targetSelector);
            } catch (e) {}
            if (section) {
                this.entries.push({ link, section });
            }
        });

        // Mobile swipe layout only when the pills don't fit: measure with the
        // default centered layout applied, then toggle the class the styles
        // key off. Re-checked on resize and after webfonts settle widths.
        this.checkOverflow = () => {
            this.classList.remove('is-overflowing');
            this.classList.toggle('is-overflowing', this.scrollWidth > this.clientWidth + 1);
        };
        this.checkOverflow();
        window.addEventListener('resize', this.checkOverflow);
        document.fonts?.ready?.then(this.checkOverflow);

        if (!this.entries.length) return;

        this.onIntersect = this.onIntersect.bind(this);
        this.observer = new IntersectionObserver(this.onIntersect, {
            rootMargin: '-40% 0px -55% 0px',
            threshold: 0,
        });
        this.entries.forEach(({ section }) => this.observer.observe(section));
    }

    onIntersect(intersectingEntries) {
        intersectingEntries.forEach((intersection) => {
            if (!intersection.isIntersecting) return;
            const activeSection = intersection.target;
            this.entries.forEach(({ link, section }) => {
                link.classList.toggle('is-active', section === activeSection);
            });
        });
    }

    detached() {
        this.observer?.disconnect();
        window.removeEventListener('resize', this.checkOverflow);
    }
}

customElements.define('block-nav', BlockNav);
